export default {
  NETWORK_ERROR: 'Unexpected error',

  403: 'You need permission to perform this action',
  404: 'Not found',
  500: 'Ops, something went wrong! Please, try again.',
}
